import React from 'react'
import Title from "./../../Title/Title";
const EmptyCart = () => {
  return (
    <div>
      <Title name="Your Cart is Empty"/>
    </div>
  )
}

export default EmptyCart
